import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { PublicLinkService } from '@simOn/public-link';
import { SimFullscreenModule } from '@simOn/ui/sim-fullscreen';
import { SimUserOnlineComponent } from '@simOn/user/last-visited/ui';
import { LoggedUserComponent } from '@simOn/user/logged/ui';
import { AiAssistantButtonComponent } from '../ai-assistant/ai-assistant-button.component';
import { OperationsInProgressButtonComponent } from '../operations-in-progress/operations-in-progress-button.component';

/** User section of the top navbar (operations in progress, AI assistant, online users, logged user, fullscreen). */
@Component({
  selector: 'layout-navbar-user',
  templateUrl: './navbar-user.component.html',
  styleUrl: './navbar-user.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    OperationsInProgressButtonComponent,
    SimUserOnlineComponent,
    AiAssistantButtonComponent,
    LoggedUserComponent,
    SimFullscreenModule
  ]
})
export class NavbarUserComponent {
  private readonly _publicLinkService = inject(PublicLinkService);
  protected readonly isPublicModeActive = toSignal(this._publicLinkService.isPublicLinkModeActive$);
}
